(function () {
  const DSH_CART_KEY =
    'adena365:dsh-cart:v1';

  const CHECKOUT_KEY_STORAGE_KEY =
    'adena365:dsh-checkout-key:v1';

  const SHOPIFY_CART_SIGNATURE_KEY =
    'adena365:dsh-shopify-cart-signature:v1';

  const CHECKOUT_URL =
    'https://test-konfigurator.adena365.de/api/dsh/cart/checkout';

  let rendering =
    false;

  let renderPending = false;

  let checkoutBusy =
    false;

  let observer =
    null;

  let observerTimer =
    null;


  function loadDshCart() {
    try {
      const raw =
        window.localStorage.getItem(
          DSH_CART_KEY
        );

      if (!raw) {
        return {
          items: []
        };
      }

      const parsed =
        JSON.parse(raw);

      return {
        items:
          Array.isArray(parsed.items)
            ? parsed.items.slice(0, 25)
            : []
      };

    } catch (error) {
      return {
        items: []
      };
    }
  }


  function saveDshCart(cart) {
    window.localStorage.setItem(
      DSH_CART_KEY,
      JSON.stringify(cart)
    );

    window.localStorage.removeItem(
      CHECKOUT_KEY_STORAGE_KEY
    );

    setCheckoutMessage('');

    window.dispatchEvent(
      new CustomEvent(
        'adena:dsh-cart-changed'
      )
    );
  }


  function money(cents) {
    return (
      Number(cents) / 100
    ).toLocaleString(
      'de-DE',
      {
        style: 'currency',
        currency: 'EUR'
      }
    );
  }


  function displayNumber(value) {
    return Number(value)
      .toLocaleString(
        'de-DE',
        {
          maximumFractionDigits: 2
        }
      );
  }


  function materialLabel(
    configuration
  ) {
    const materialText =
      configuration.material ===
        'petg-transparent'
        ? 'PETG Transparent'
        : configuration.material ===
            'petg-cf'
          ? 'PETG CF'
          : 'PETG Standard';

    const colorText =
      configuration.color ===
        'white'
        ? 'Weiß'
        : configuration.color ===
            'gray'
          ? 'Grau'
          : configuration.color ===
              'transparent'
            ? 'Transparent'
            : 'Schwarz';

    return (
      materialText +
      ' · ' +
      colorText
    );
  }



  function dshConfiguredTitle(
    configuration,
    geometryReference,
    fallbackName
  ) {
    const base =
      configuration.productType ===
        'disc'
        ? 'Distanzscheibe'
        : 'Distanzhülse';

    if (
      geometryReference &&
      geometryReference.kind === 'exact'
    ) {
      return base + ' – konfigurierte Variante';
    }

    if (
      geometryReference &&
      geometryReference.kind === 'comparable'
    ) {
      return base + ' nach Maß';
    }

    return fallbackName ||
      base + ' – Konfiguration';
  }


  function dshCartImageUrl(
    configuration
  ) {
    const config =
      document.getElementById(
        'dsh-cart-image-config'
      );

    if (!config) {
      return '';
    }

    return configuration.productType ===
      'disc'
      ? config.dataset.discImage || ''
      : config.dataset.sleeveImage || '';
  }


  function dshSubtotal(
    cart
  ) {
    return cart.items.reduce(
      function (
        sum,
        item
      ) {
        return (
          sum +
          Number(
            item.priceSnapshot
              ?.grossProductPriceCents ||
            0
          )
        );
      },
      0
    );
  }


  function createDshLines(
    cart
  ) {
    const wrapper =
      document.createElement(
        'div'
      );

    wrapper.className =
      'dsh-shop-cart-lines';

    wrapper.dataset.dshShopCartLines =
      'true';

    const title =
      document.createElement(
        'div'
      );

    title.className =
      'dsh-shop-cart-lines__title';

    title.textContent =
      'Individuelle Kunststoffteile';

    wrapper.appendChild(
      title
    );


    cart.items.forEach(
      function (
        item
      ) {
        const config =
          item.request
            ?.configuration;

        if (!config) {
          return;
        }

        const dims =
          config.dimensions;

        const row =
          document.createElement(
            'div'
          );

        row.className =
          'dsh-shop-cart-line';

        const media =
          document.createElement(
            'div'
          );

        media.className =
          'dsh-shop-cart-line__media';

        const imageUrl =
          dshCartImageUrl(
            config
          );

        if (imageUrl) {
          const image =
            document.createElement(
              'img'
            );

          image.src =
            imageUrl;

          image.alt =
            dshConfiguredTitle(
              config,
              item.geometryReference,
              item.displayName
            );

          image.loading =
            'lazy';

          media.appendChild(
            image
          );
        }

        const copy =
          document.createElement(
            'div'
          );

        copy.className =
          'dsh-shop-cart-line__copy';

        const name =
          document.createElement(
            'strong'
          );

        name.textContent =
          dshConfiguredTitle(
            config,
            item.geometryReference,
            item.displayName
          );

        const dimension =
          document.createElement(
            'span'
          );

        dimension.textContent =
          'AD ' +
          displayNumber(
            dims.outerDiameterMm
          ) +
          ' × ID ' +
          displayNumber(
            dims.innerDiameterMm
          ) +
          ' × ' +
          (
            config.productType ===
              'disc'
              ? 'H '
              : 'L '
          ) +
          displayNumber(
            dims.thirdDimensionMm
          ) +
          ' mm';

        const details =
          document.createElement(
            'span'
          );

        details.textContent =
          materialLabel(config) +
          ' · ' +
          config.quantity +
          ' Stück';

        copy.appendChild(
          name
        );

        copy.appendChild(
          dimension
        );

        copy.appendChild(
          details
        );

        const actions =
          document.createElement(
            'div'
          );

        actions.className =
          'dsh-shop-cart-line__actions';

        const price =
          document.createElement(
            'strong'
          );

        price.textContent =
          money(
            item.priceSnapshot
              ?.grossProductPriceCents ||
            0
          );

        const remove =
          document.createElement(
            'button'
          );

        remove.type =
          'button';

        remove.className =
          'dsh-shop-cart-line__remove';

        remove.textContent =
          'Entfernen';

        remove.addEventListener(
          'click',
          function () {
            saveDshCart({
              items:
                loadDshCart()
                  .items
                  .filter(
                    function (
                      current
                    ) {
                      return (
                        current.id !==
                        item.id
                      );
                    }
                  )
            });
          }
        );

        actions.appendChild(
          price
        );

        actions.appendChild(
          remove
        );

        row.appendChild(
          media
        );

        row.appendChild(
          copy
        );

        row.appendChild(
          actions
        );

        wrapper.appendChild(
          row
        );
      }
    );


    return wrapper;
  }


  async function loadShopifyCart() {
    const response =
      await fetch(
        '/cart.js',
        {
          credentials:
            'same-origin',

          cache:
            'no-store',

          headers: {
            'Accept':
              'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'Shopify-Warenkorb konnte nicht geladen werden.'
      );
    }

    return response.json();
  }


  function normalizedShopifyItems(
    cart
  ) {
    if (
      !cart ||
      !Array.isArray(
        cart.items
      )
    ) {
      throw new Error(
        'Shopify-Warenkorb hat ein ungültiges Format.'
      );
    }

    const quantities =
      new Map();

    cart.items.forEach(
      function (
        item
      ) {
        const variantId =
          String(
            item.variant_id ||
            ''
          );

        const quantity =
          Number(
            item.quantity
          );

        if (
          !/^\d+$/.test(
            variantId
          ) ||
          !Number.isSafeInteger(
            quantity
          ) ||
          quantity < 1
        ) {
          throw new Error(
            'Shopify-Warenkorb enthält eine ungültige Position.'
          );
        }

        const gid =
          'gid://shopify/ProductVariant/' +
          variantId;

        quantities.set(
          gid,
          (
            quantities.get(
              gid
            ) ||
            0
          ) +
          quantity
        );
      }
    );

    return Array.from(
      quantities.entries()
    )
      .map(
        function (
          entry
        ) {
          return {
            variantId:
              entry[0],

            quantity:
              entry[1]
          };
        }
      )
      .sort(
        function (
          a,
          b
        ) {
          return a.variantId
            .localeCompare(
              b.variantId
            );
        }
      );
  }


  function isUuidV4(
    value
  ) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      .test(
        value ||
        ''
      );
  }


  function createUuidV4() {
    if (
      window.crypto &&
      typeof window.crypto
        .randomUUID ===
        'function'
    ) {
      return window.crypto
        .randomUUID()
        .toLowerCase();
    }

    const bytes =
      new Uint8Array(16);

    window.crypto
      .getRandomValues(
        bytes
      );

    bytes[6] =
      (
        bytes[6] &
        15
      ) |
      64;

    bytes[8] =
      (
        bytes[8] &
        63
      ) |
      128;

    const hex =
      Array.from(bytes)
        .map(
          function (
            byte
          ) {
            return byte
              .toString(16)
              .padStart(
                2,
                '0'
              );
          }
        );

    return (
      hex.slice(0, 4).join('') +
      '-' +
      hex.slice(4, 6).join('') +
      '-' +
      hex.slice(6, 8).join('') +
      '-' +
      hex.slice(8, 10).join('') +
      '-' +
      hex.slice(10, 16).join('')
    );
  }


  function getCheckoutKey(
    shopifyItems
  ) {
    const signature =
      JSON.stringify(
        shopifyItems
      );

    const previous =
      window.localStorage
        .getItem(
          SHOPIFY_CART_SIGNATURE_KEY
        );

    if (
      previous !== null &&
      previous !== signature
    ) {
      window.localStorage
        .removeItem(
          CHECKOUT_KEY_STORAGE_KEY
        );
    }

    window.localStorage
      .setItem(
        SHOPIFY_CART_SIGNATURE_KEY,
        signature
      );

    const existing =
      window.localStorage
        .getItem(
          CHECKOUT_KEY_STORAGE_KEY
        );

    if (
      isUuidV4(
        existing
      )
    ) {
      return existing
        .toLowerCase();
    }

    const created =
      createUuidV4();

    window.localStorage
      .setItem(
        CHECKOUT_KEY_STORAGE_KEY,
        created
      );

    return created;
  }


  function updateHeaderCartBubble(
    shopifyCart,
    dshCart
  ) {
    const shopifyCount =
      Number(
        shopifyCart
          ?.item_count ||
        0
      );

    const dshCount =
      dshCart.items.length;

    const combinedCount =
      shopifyCount +
      dshCount;

    document.querySelectorAll(
      '[ref="cartBubbleCount"]'
    ).forEach(
      function (
        count
      ) {
        count.textContent =
          combinedCount < 100
            ? String(
                combinedCount
              )
            : '';

        count.classList.toggle(
          'hidden',
          combinedCount === 0
        );
      }
    );

    document.querySelectorAll(
      '[ref="cartBubble"]'
    ).forEach(
      function (
        bubble
      ) {
        bubble.classList.toggle(
          'visually-hidden',
          combinedCount === 0
        );

        if (
          combinedCount <= 99
        ) {
          bubble.setAttribute(
            'data-maintain-ratio',
            ''
          );
        } else {
          bubble.removeAttribute(
            'data-maintain-ratio'
          );
        }
      }
    );

    document.querySelectorAll(
      'cart-icon'
    ).forEach(
      function (
        icon
      ) {
        icon.classList.toggle(
          'header-actions__cart-icon--has-cart',
          combinedCount > 0
        );
      }
    );

    try {
      window.sessionStorage.setItem(
        'cart-count',
        JSON.stringify({
          value:
            String(
              combinedCount
            ),

          timestamp:
            Date.now()
        })
      );
    } catch (error) {
      // Nur Anzeigeoptimierung.
    }
  }


  function updateCheckoutLabels(
    hasDsh
  ) {
    document.querySelectorAll(
      '.cart__checkout-button .button-text'
    ).forEach(
      function (
        label
      ) {
        label.textContent =
          hasDsh
            ? 'Gemeinsam zur Kasse'
            : 'Sicher zur Kasse';
      }
    );
  }


  function updateDisplayedTotals(
    shopifyCart,
    dshCart
  ) {
    const combined =
      Number(
        shopifyCart
          ?.total_price ||
        0
      ) +
      dshSubtotal(
        dshCart
      );

    document.querySelectorAll(
      '[data-cart-subtotal]'
    ).forEach(
      function (
        node
      ) {
        const value =
          money(
            combined
          );

        if (
          node.textContent
            ?.trim() !==
          value
        ) {
          node.textContent =
            value;

          node.setAttribute(
            'value',
            value
          );
        }
      }
    );
  }


  function injectDshLines(
    cart
  ) {
    document.querySelectorAll(
      '[data-dsh-shop-cart-lines]'
    ).forEach(
      function (
        node
      ) {
        node.remove();
      }
    );

    if (
      cart.items.length <
      1
    ) {
      return;
    }

    document.querySelectorAll(
      '.cart-drawer__items'
    ).forEach(
      function (
        container
      ) {
        container.appendChild(
          createDshLines(
            cart
          )
        );
      }
    );

    document.querySelectorAll(
      'main .cart-items__wrapper'
    ).forEach(
      function (
        container
      ) {
        container.appendChild(
          createDshLines(
            cart
          )
        );
      }
    );
  }


  function createDshOnlyCartSummary(
    dshCart
  ) {
    const subtotal =
      dshSubtotal(
        dshCart
      );

    const shipping =
      subtotal >= 995
        ? 0
        : 195;

    const total =
      subtotal +
      shipping;

    const summary =
      document.createElement(
        'div'
      );

    summary.className =
      'dsh-only-cart-summary';

    summary.dataset.dshOnlyCartSummary =
      'true';

    const totals =
      document.createElement(
        'div'
      );

    totals.className =
      'dsh-only-cart-summary__totals';

    const totalLabel =
      document.createElement(
        'span'
      );

    totalLabel.textContent =
      'Gesamtbetrag';

    const totalValue =
      document.createElement(
        'strong'
      );

    totalValue.textContent =
      money(
        total
      );

    totals.appendChild(
      totalLabel
    );

    totals.appendChild(
      totalValue
    );

    const shippingNote =
      document.createElement(
        'p'
      );

    shippingNote.className =
      'dsh-only-cart-summary__shipping';

    shippingNote.textContent =
      shipping === 0
        ? 'Versandkostenfrei in Deutschland'
        : 'inkl. 1,95 € Versand & Verpackung';

    const checkout =
      document.createElement(
        'button'
      );

    checkout.type =
      'button';

    checkout.className =
      'cart__checkout-button button dsh-only-cart-summary__checkout';

    const checkoutLabel =
      document.createElement(
        'span'
      );

    checkoutLabel.className =
      'button-text';

    checkoutLabel.textContent =
      'Gemeinsam zur Kasse';

    checkout.appendChild(
      checkoutLabel
    );

    summary.appendChild(
      totals
    );

    summary.appendChild(
      shippingNote
    );

    summary.appendChild(
      checkout
    );

    return summary;
  }


  function updateDshOnlyCartState(
    shopifyCart,
    dshCart
  ) {
    document.querySelectorAll(
      '[data-dsh-only-cart-summary]'
    ).forEach(
      function (
        node
      ) {
        node.remove();
      }
    );

    const dshOnly =
      dshCart.items.length > 0 &&
      Number(
        shopifyCart
          ?.item_count ||
        0
      ) === 0;

    document.documentElement
      .classList.toggle(
        'dsh-only-cart-active',
        dshOnly
      );

    if (!dshOnly) {
      return;
    }

    document.querySelectorAll(
      '.cart-drawer__content'
    ).forEach(
      function (
        content
      ) {
        content.appendChild(
          createDshOnlyCartSummary(
            dshCart
          )
        );
      }
    );

    document.querySelectorAll('main .cart-page').forEach(function (page) {
      const summary = createDshOnlyCartSummary(dshCart);
      summary.classList.add('cart-page__summary');
      page.insertBefore(summary, page.querySelector('.cart-page__more-blocks'));
    });
  }


  function updateEmptyCartPresentation(shopifyCart, dshCart) {
    const nativeCount = Number(shopifyCart?.item_count || 0);
    const dshOnly = nativeCount === 0 && dshCart.items.length > 0;
    const cartLabel = document.querySelector('.cart-drawer__content[aria-label]')
      ?.getAttribute('aria-label') || 'Warenkorb';

    document.querySelectorAll('main .cart-page__title h1, .cart-drawer__content > h2')
      .forEach(function (heading) {
        if (dshOnly) {
          if (!heading.hasAttribute('data-dsh-empty-heading')) {
            heading.setAttribute('data-dsh-empty-heading', heading.innerHTML);
          }
          heading.textContent = cartLabel;
        } else if (heading.hasAttribute('data-dsh-empty-heading')) {
          if (nativeCount === 0) {
            heading.innerHTML = heading.getAttribute('data-dsh-empty-heading');
          }
          heading.removeAttribute('data-dsh-empty-heading');
        }
      });

    const count = nativeCount + dshCart.items.length;
    document.querySelectorAll('#cart-drawer .theme-drawer__badge').forEach(function (badge) {
      badge.textContent = count <= 99 ? String(count) : '';
      badge.classList.toggle('visually-hidden', count === 0);
    });
    document.querySelectorAll('[data-testid="cart-count-live-region"], #cart-drawer-heading .visually-hidden')
      .forEach(function (node) {
        node.textContent = node.textContent.replace(/\d+\s*$/, String(count));
      });
  }


  async function render() {
    if (rendering) {
      renderPending = true;
      return;
    }

    rendering = true;

    try {
      const shopifyCart = await loadShopifyCart();
      const dshCart = loadDshCart();
      const hasDsh = dshCart.items.length > 0;

      if (observer) {
        observer.disconnect();
      }

      try {
        document.documentElement.classList.toggle('dsh-mixed-cart-active', hasDsh);

        document.querySelectorAll('.cart-title .cart-bubble').forEach(function (bubble) {
          bubble.style.display = hasDsh ? 'none' : '';
        });

        updateCheckoutLabels(hasDsh);
        injectDshLines(dshCart);
        updateHeaderCartBubble(shopifyCart, dshCart);
        updateDshOnlyCartState(shopifyCart, dshCart);
        updateEmptyCartPresentation(shopifyCart, dshCart);
        updateDisplayedTotals(shopifyCart, dshCart);
      } finally {
        if (observer && document.body) {
          observer.observe(document.body, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    } catch (error) {
      console.warn('[dsh-shop-cart]', error);
    } finally {
      rendering = false;
      if (renderPending) {
        renderPending = false;
        render();
      }
    }
  }


  function setCheckoutMessage(
    message
  ) {
    const shouldReconnectObserver =
      Boolean(
        observer &&
        document.body
      );

    if (shouldReconnectObserver) {
      observer.disconnect();
    }

    try {
      document.querySelectorAll(
        '[data-dsh-mixed-checkout-message]'
      ).forEach(
        function (
          node
        ) {
          node.remove();
        }
      );

      if (!message) {
        return;
      }

      const checkout =
        document.querySelector(
          '.cart__checkout-button'
        );

      if (!checkout) {
        return;
      }

      const node =
        document.createElement(
          'p'
        );

      node.className =
        'dsh-mixed-checkout-message';

      node.dataset.dshMixedCheckoutMessage =
        'true';

      node.textContent =
        message;

      checkout.insertAdjacentElement(
        'afterend',
        node
      );

    } finally {
      if (
        shouldReconnectObserver &&
        observer &&
        document.body
      ) {
        observer.observe(
          document.body,
          {
            childList:
              true,

            characterData:
              true,

            subtree:
              true
          }
        );
      }
    }
  }


  async function mixedCheckout() {
    if (checkoutBusy) {
      return;
    }

    const dshCart =
      loadDshCart();

    if (
      dshCart.items.length <
      1
    ) {
      return;
    }

    checkoutBusy =
      true;

    const buttons =
      Array.from(
        document.querySelectorAll(
          '.cart__checkout-button'
        )
      );

    buttons.forEach(
      function (
        button
      ) {
        button.disabled =
          true;

        const label =
          button.querySelector(
            '.button-text'
          );

        if (label) {
          label.textContent =
            'Warenkorb wird geprüft …';
        }
      }
    );

    try {
      const shopifyCart =
        await loadShopifyCart();

      const shopifyItems =
        normalizedShopifyItems(
          shopifyCart
        );

      const response =
        await fetch(
          CHECKOUT_URL,
          {
            method:
              'POST',

            mode:
              'cors',

            headers: {
              'Content-Type':
                'application/json'
            },

            body:
              JSON.stringify({
                checkoutKey:
                  getCheckoutKey(
                    shopifyItems
                  ),

                items:
                  dshCart.items.map(
                    function (
                      item
                    ) {
                      return item.request;
                    }
                  ),

                shopifyItems
              })
          }
        );

      const payload =
        await response.json();

      if (
        response.ok &&
        payload.status ===
          'checkout-ready' &&
        payload.checkout
          ?.invoiceUrl
      ) {
        window.location.assign(
          payload.checkout
            .invoiceUrl
        );

        return;
      }

      if (
        response.ok &&
        payload.status ===
          'staging-ready'
      ) {
        setCheckoutMessage(
          'Gemeinsam geprüft: ' +
          money(
            payload.summary
              .totalCents
          ) +
          ' Gesamtbetrag. Im Staging wird noch kein echter Checkout geöffnet.'
        );

        return;
      }

      throw new Error(
        payload
          ?.message ||
        'Der gemeinsame Warenkorb konnte nicht geprüft werden.'
      );

    } catch (
      error
    ) {
      setCheckoutMessage(
        error &&
        typeof error.message ===
          'string'
          ? error.message
          : 'Der gemeinsame Warenkorb konnte technisch nicht geprüft werden.'
      );

    } finally {
      checkoutBusy =
        false;

      buttons.forEach(
        function (
          button
        ) {
          button.disabled =
            false;

          const label =
            button.querySelector(
              '.button-text'
            );

          if (label) {
            label.textContent =
              'Gemeinsam zur Kasse';
          }
        }
      );
    }
  }


  document.addEventListener(
    'click',
    function (
      event
    ) {
      const target =
        event.target instanceof
          Element
          ? event.target
          : null;

      if (!target) {
        return;
      }

      const configuratorAdd =
        target.closest(
          '[data-cart-button]'
        );

      if (
        configuratorAdd
      ) {
        window.setTimeout(
          function () {
            render();
          },
          40
        );

        return;
      }

      const checkout =
        target.closest(
          '.cart__checkout-button'
        );

      if (
        checkout &&
        loadDshCart()
          .items
          .length >
          0
      ) {
        event.preventDefault();
        event.stopPropagation();

        mixedCheckout();
      }
    },
    true
  );


  document.addEventListener(
    'submit',
    function (
      event
    ) {
      const form =
        event.target;

      if (
        form instanceof
          HTMLFormElement &&
        form.id ===
          'cart-form' &&
        loadDshCart()
          .items
          .length >
          0
      ) {
        event.preventDefault();
        event.stopPropagation();

        mixedCheckout();
      }
    },
    true
  );


  window.addEventListener(
    'adena:dsh-cart-changed',
    render
  );


  window.addEventListener(
    'storage',
    function (
      event
    ) {
      if (
        event.key ===
        DSH_CART_KEY
      ) {
        render();
      }
    }
  );


  observer =
    new MutationObserver(
      function () {
        if (
          loadDshCart()
            .items
            .length >
          0
        ) {
          window.clearTimeout(
            observerTimer
          );

          observerTimer =
            window.setTimeout(
              render,
              60
            );
        }
      }
    );

  observer.observe(
    document.body,
    {
      childList:
        true,

      characterData:
        true,

      subtree:
        true
    }
  );


  render();
})();